<script>
    // @ts-nocheck
    import {t} from '$utils/lang.js';

    const {orderId = '', isLeasing = false, isGuest = false} = $props();

    let reviewLoading = $state(false);
    let reviewDone = $state(false);

    let createAccountLoading = $state(false);
    let createAccountDone = $state(false);

    async function requestPasswordSet() {
        createAccountLoading = true;
        try {
            const params = new URLSearchParams({cl: 'm7-checkout-doc', fnc: 'requestPasswordSet'});
            const resp = await fetch(`/index.php?${params}`, {credentials: 'include'});
            const data = await resp.json().catch(() => null);
            if (data?.success) createAccountDone = true;
        } finally {
            createAccountLoading = false;
        }
    }

    async function requestReviewEmail() {
        reviewLoading = true;
        try {
            const params = new URLSearchParams({cl: 'm7-checkout-doc', fnc: 'getTrustedShopsData'});
            const resp = await fetch(`/index.php?${params}`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                credentials: 'include',
                body: JSON.stringify({orderId}),
            });
            const data = await resp.json();
            if (data.success) {
                injectTrustedShopsDOM(data);
                reviewDone = true;
            }
        } finally {
            reviewLoading = false;
        }
    }

    function injectTrustedShopsDOM(data) {
        document.getElementById('trustedShopsCheckout')?.remove();

        const root = document.createElement('div');
        root.id = 'trustedShopsCheckout';
        root.style.display = 'none';

        const s = (id, text) => {
            const el = document.createElement('span');
            el.id = id;
            el.textContent = String(text ?? '');
            return el;
        };
        const sc = (cls, text) => {
            const el = document.createElement('span');
            el.className = cls;
            el.textContent = String(text ?? '');
            return el;
        };

        root.appendChild(s('tsCheckoutOrderNr', data.orderNr));
        root.appendChild(s('tsCheckoutBuyerEmail', data.email));
        root.appendChild(s('tsCheckoutOrderAmount', data.amount));
        root.appendChild(s('tsCheckoutOrderCurrency', data.currency));
        root.appendChild(s('tsCheckoutOrderPaymentType', data.paymentType));
        root.appendChild(s('tsCheckoutOrderEstDeliveryDate', ''));

        for (const p of data.products ?? []) {
            const item = document.createElement('span');
            item.className = 'tsCheckoutProductItem';
            item.appendChild(sc('tsCheckoutProductUrl', p.url));
            item.appendChild(sc('tsCheckoutProductImageUrl', p.imageUrl));
            item.appendChild(sc('tsCheckoutProductName', p.name));
            item.appendChild(sc('tsCheckoutProductSKU', p.sku));
            item.appendChild(sc('tsCheckoutProductGTIN', p.gtin));
            item.appendChild(sc('tsCheckoutProductMPN', p.mpn));
            item.appendChild(sc('tsCheckoutProductBrand', p.brand));
            root.appendChild(item);
        }

        document.body.appendChild(root);

        if (window.trustbadge?.reInitialize) {
            window.trustbadge.reInitialize();
        } else if (data.tsId) {
            const script = document.createElement('script');
            script.charset = 'utf-8';
            script.src = `//widgets.trustedshops.com/js/${data.tsId}.js`;
            document.head.appendChild(script);
        }
    }
</script>

<div class="lg:max-w-105 lg:mx-auto" data-checkout-step="thankyou" data-order-id={orderId}>

    <!-- Confirmation card -->
    <div class="bg-white rounded-md shadow-sm p-7.5 flex flex-col items-center gap-5.5">

        <!-- Green checkmark icon -->
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="30" cy="30" r="25" stroke="#00C950" stroke-width="5" stroke-linecap="round"/>
            <path d="M18 30.5l8.5 8.5 15-15" stroke="#00C950" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>

        <!-- Heading -->
        <h2 class="text-[22.5px] font-bold text-[#1e2939] text-center leading-[30px]">
            {t('Vielen Dank für deine Bestellung!')}
        </h2>

        <!-- Subtext -->
        <p class="text-[13px] font-light text-[#4a5565] text-center leading-[18.75px]">
            {t('Eine Bestätigungs-E-Mail wurde an deine angegebene E-Mail-Adresse versendet.')}
        </p>

        {#if isLeasing}
        <p class="text-[13px] font-light text-[#4a5565] text-center leading-[18.75px]">
            {t('Bitte beachte: Wir versenden dein Fahrrad erst, sobald wir die Freigabe durch deinen Leasing-Anbieter erhalten haben.')}
        </p>
        {/if}

        <!-- CTA buttons -->
        <div class="flex flex-col gap-[15px] w-full">

            <!-- Review email -->
            {#if !reviewDone}
            <div class="bg-gray-50 border border-black/10 rounded-[9.38px] p-4" data-checkout-section="thankyou-review-email">
                <button
                    type="button"
                    class="w-full bg-white border-2 border-cyprus text-cyprus font-bold text-[15px] rounded-[9.38px] py-[13px] px-[17px] cursor-pointer hover:bg-cyprus/5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    data-checkout-action="request-review-email"
                    onclick={requestReviewEmail}
                    disabled={reviewLoading}
                >
                    {reviewLoading ? t('Wird gesendet…') : t('Ja, ich möchte eine Bewertungs-E-Mail erhalten')}
                </button>
            </div>
            {/if}

            <!-- Create account (guests only) -->
            {#if isGuest}
            <div class="bg-gray-50 border border-black/10 rounded-[9.38px] p-4" data-checkout-section="thankyou-create-account">
                {#if createAccountDone}
                    <p class="text-center text-sm text-[#4a5565]">{t('Wir haben dir eine E-Mail zum Festlegen deines Passworts geschickt.')}</p>
                {:else}
                    <button
                        type="button"
                        class="w-full bg-white border-2 border-cyprus text-cyprus font-bold text-[15px] rounded-[9.38px] py-[13px] px-[17px] cursor-pointer hover:bg-cyprus/5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        data-checkout-action="create-account"
                        onclick={requestPasswordSet}
                        disabled={createAccountLoading}
                    >
                        {createAccountLoading ? t('Wird gesendet…') : t('Ja, Konto anlegen')}
                    </button>
                {/if}
            </div>
            {/if}

        </div>

    </div>

</div>
